<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>資訊</f7-nav-title>
    </f7-navbar>

    悠遊餐飲國際有限公司<br>0931-192-298<br>
    建置版本: {{ version }}
    <f7-button
      style="margin: 30px;"
      fill
      raised
      @click="clearCache">
      Clear Cache
    </f7-button>
    <!-- <div v-for="(log, index) in connectionLogs" :key="`connectionLogs-${index}`">{{log}}</div> -->
    {{ connectionLog }}
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import localforage from 'localforage'

export default {
  data () {
    return {
      version: process.env.VUE_APP_VERSION
    }
  },
  created () {
  },
  computed: {
    ...mapState(['connectionLog'])
  },
  methods: {
    clearCache () {
      localforage.clear()
    }
  },
  components: {
  }
}
</script>
